import React from 'react';
import { PRIVACY_POLICY } from '../../config/legalContent';
import { LegalDocument } from '../../components/LegalDocument';
import { CloseIcon } from '../../components/icons';

interface PrivacyPolicyModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export const PrivacyPolicyModal: React.FC<PrivacyPolicyModalProps> = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 w-full h-full flex justify-center items-center bg-black/70 backdrop-blur-sm z-50 p-4">
            <div className="relative w-full max-w-4xl max-h-[90vh] bg-grayscale-100 rounded-2xl flex flex-col shadow-custom-light">
                {/* Close button */}
                <div className="absolute top-0 right-0 pt-6 pr-6 z-10">
                    <button onClick={onClose} className="flex p-2.5 justify-center items-center gap-2 rounded-full bg-grayscale-1200 shadow-custom-light">
                        <CloseIcon />
                    </button>
                </div>

                {/* Content */}
                <div className="flex flex-col gap-6 p-6 overflow-y-auto hide-scrollbar">
                    {/* Header */}
                    <div className="flex items-center justify-between border-b border-grayscale-800 pb-4">
                        <h1 className="text-grayscale-1300 font-grotesk text-xl font-medium">
                            Privacy Policy
                        </h1>
                    </div>

                    {/* Content */}
                    <div className="flex flex-col gap-6 text-grayscale-1200 font-grotesk">
                        <LegalDocument doc={PRIVACY_POLICY} />
                    </div>
                </div>
            </div>
        </div>
    );
};
